import {
  Button,
  ButtonGroup,
  Card,
  Stack,
  Subheading,
  TextContainer
} from "@shopify/polaris";
import React, { useContext, useState } from "react";
import copy from "content/copy.json";
import { createRecurringCharge } from "api/recurring-charges";
import { NavigationContext } from "contexts/Navigation";
import useToast from "hooks/useToast";

type RecurringChargesResponse = {
  data: { redirectUrl: string };
  error: Error;
};

const {
  percentagePlanCardTerm1,
  percentagePlanCardTerm2,
  percentagePlanCardTerm3,
  percentagePlanCardAction,
  percentagePlanCardTitle
} = copy.account.percentageVolumetric;

function PlanCard() {
  const navigation = useContext(NavigationContext);
  const [loading, setLoading] = useState<boolean>(false);
  const { showToast } = useToast();
  async function activateRecurringCharge() {
    setLoading(true);
    const response =
      (await createRecurringCharge()) as RecurringChargesResponse;
    if (response.error) {
      const errorMessage =
        "We're sorry, an error has occurred. Please try again.";
      setLoading(false);
      showToast({
        message: errorMessage
      });
    } else {
      navigation.redirect(response.data.redirectUrl);
    }
  }
  return (
    <Card title={percentagePlanCardTitle}>
      <Card.Section>
        <Stack spacing="loose" vertical>
          <TextContainer>
            <Subheading>{percentagePlanCardTerm1}</Subheading>
            <Subheading>{percentagePlanCardTerm2}</Subheading>
            <p>{percentagePlanCardTerm3}</p>
          </TextContainer>
          <Stack distribution="trailing">
            <ButtonGroup>
              <Button
                onClick={activateRecurringCharge}
                loading={loading}
                primary
              >
                {percentagePlanCardAction}
              </Button>
            </ButtonGroup>
          </Stack>
        </Stack>
      </Card.Section>
    </Card>
  );
}
export default PlanCard;
